import { createAsyncThunk } from '@reduxjs/toolkit';
import { getTypeOfContentExistsForClient } from './home-api';
import type { IRootState } from '../../app/store';

export const getTypeOfContentExistsForClientThunk = createAsyncThunk(
    'home/getTypeOfContentExistsForClient',
    async (clientId: Number, { rejectWithValue, getState }) => {
        try {
            const { isWhitelisted } = (getState() as IRootState)
                .referentialAccess;
            const response = await getTypeOfContentExistsForClient(
                clientId,
                isWhitelisted
            );
            return response.data;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
